'use client';

import Link from 'next/link';

const MediaPartnersSection = () => {
  const MediaPartnersLogos = [
  {
    src: "/images/voice-of-crypto.webp",
    alt: "Voice of Crypto",
    link: "https://voiceofcrypto.online/",
  },
  {
    src: "/images/cryptopulsenews.svg",
    alt: "CryptoPulse News",
    link: "https://cryptopulse.news/",
  },
  {
      src: '/images/coinlytix-logo.webp',
      alt: 'coinlytix-logo',
      link: 'https://coinlytx.com/',
    },
  {
    src: "/images/coinraftar.webp",
    alt: "CoinRaftar",
    link: "https://coinraftar.com/",
  },
  {
    src: "/images/etherpr.webp",
    alt: "EtherPR",
    link: "https://etherpr.com/",
  },
  {
    src: "/images/dgroup-capital.webp",
    alt: "DGroup Capital",
    link: "https://dgroup.capital/",
  },
  {
    src: "/images/crypto-news.webp",
    alt: "Crypto News",
    link: "https://crypto.news/",
  },
  {
    src: "/images/cfeablack.webp",
    alt: "CoinFea",
    link: "https://coinfea.com/",
  },
  {
    src: "/images/securities-io.webp",
    alt: "Securities.io",
    link: "https://www.securities.io/",
  },
  {
    src: "/images/blockweeks.webp",
    alt: "BlockWeeks",
    link: "https://blockweeks.com/",
  },
  {
    src: "/images/bitcoinworld.webp",
    alt: "Bitcoin World",
    link: "https://bitcoinworld.co.in/",
  },
  {
    src: "/images/incrypted.webp",
    alt: "Incrypted",
    link: "https://incrypted.com/",
  },
  {
    src: "/images/cryptonomist.webp",
    alt: "Cryptonomist",
    link: "https://en.cryptonomist.ch/",
  },
  {
    src: "/images/cryptopress.webp",
    alt: "CryptoPress",
    link: "https://cryptopress.site/",
  },
  {
    src: "/images/bdventures.webp",
    alt: "BD Ventures",
    link: "https://www.bdventures.vn/",
  },
  {
    src: "/images/cryptobrowser.webp",
    alt: "CryptoBrowser",
    link: "https://cryptobrowser.io/",
  },
  {
    src: "/images/theholycoins.webp",
    alt: "The Holy Coins",
    link: "https://theholycoins.com/",
  },
  {
    src: "/images/bfmtimes.webp",
    alt: "BFM Times",
    link: "https://bfmtimes.com/",
  },
  {
    src: "/images/bitcoininsider-logo.webp",
    alt: "Bitcoin Insider",
    link: "https://www.bitcoininsider.org/",
  },
  {
    src: "/images/smartmoneymatch-black.webp",
    alt: "Smart Money Match",
    link: "https://www.smartmoneymatch.com/help/media-partnerships",
  },
  {
    src: "/images/transportstake.webp",
    alt: "TransportStake",
    link: "https://www.transportstake.com/",
  },
  {
    src: "/images/publicitymarketplace.webp",
    alt: "Publicity Marketplace",
    link: "https://www.publicitymarketplace.com/",
  },
  {
    src: "/images/functionalsourcing-colored.webp",
    alt: "Functional Sourcing",
    link: "https://www.functionalsourcing.com/",
  },
  {
    src: "/images/educationstake-colored.webp",
    alt: "EducationStake",
    link: "https://www.educationstake.com/",
  },
  {
    src: "/images/match-sdg-logo.webp",
    alt: "MatchSDG",
    link: "https://www.matchsdg.com/en/media-library",
  },
  {
    src: "/images/livebitcoinnews.webp",
    alt: "livebitcoinnews",
    link: "https://www.livebitcoinnews.com/",
  },
  {
    src: "/images/coinrab.webp",
    alt: "coinrab",
    link: "https://coinrab.com/",
  },
  {
    src: "/images/brandpr.webp",
    alt: "brandpr",
    link: "https://brandpr.io/",
  },
  {
    src: "/images/exchange1-logo.webp",
    alt: "brandpr",
    link: "https://www.exchange1.com/",
  },
  {
    src: "/images/zexprwire-logo.webp",
    alt: "zexprwire",
    link: "https://zexprwire.com/",
  },
  {
  src: "/images/wamda-logo.webp",
  alt: "Wamda",
  link: "https://www.wamda.com/",
},
{
  src: "/images/startupnews-logo.webp",
  alt: "Startup News",
  link: "https://startupnews.fyi/",
},
{
  src: "/images/privatebanking-logo.webp",
  alt: "Private Banking",
  link: "https://www.privatebanking.com/",
},
{
  src: "/images/alhuda.webp",
  alt: "Alhuda CIBE",
  link: "https://www.alhudacibe.com/",
},
{
  src: "/images/alhudatoday-logo.webp",
  alt: "Alhuda Today",
  link: "https://www.alhudatoday.com/",
},
{
  src: "/images/startupcity-us.webp",
  alt: "Startup City",
  link: "https://www.startupcity.com/",
},
{
  src: "/images/gazetinternational.webp",
  alt: "Gazet International",
  link: "https://gazetinternational.com/",
},
{
  src: "/images/walletinvestor.svg",
  alt: "Wallet Investor",
  link: "https://walletinvestor.com/",
},
{
  src: "/images/brila-logo.webp",
  alt: "Brila",
  link: "https://brila.net/",
},
{
  src: "/images/edarabia.webp",
  alt: "edarabia",
  link: "https://www.edarabia.com/",
},
];

  return (
    <section data-component-id="src/app/MediaPartnersSection.tsx:210:4" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="210" data-component-file="MediaPartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20bg-secondary-light%20py-10%22%7D"
      id="partners"
      className="w-full bg-secondary-light py-10"
    >
      <div data-component-id="src/app/MediaPartnersSection.tsx:214:6" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="214" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-%5B5px%5D%20sm%3Apx-6%20lg%3Apx-%5B56px%5D%22%7D" className="w-full max-w-[1440px] mx-auto px-[5px] sm:px-6 lg:px-[56px]">
        <div data-component-id="src/app/MediaPartnersSection.tsx:215:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="215" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B24px%5D%20sm%3Agap-%5B30px%5D%20lg%3Agap-%5B36px%5D%20justify-center%20items-center%20max-w-%5B1140px%5D%20mx-auto%22%7D" className="flex flex-col gap-[24px] sm:gap-[30px] lg:gap-[36px] justify-center items-center max-w-[1140px] mx-auto">
          {/* Section Header */}
          <h2 data-component-id="src/app/MediaPartnersSection.tsx:217:10" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="217" data-component-file="MediaPartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B24px%5D%20lg%3Atext-3xl%20font-semibold%20leading-%5B28px%5D%20sm%3Aleading-%5B32px%5D%20lg%3Aleading-4xl%20text-center%20text-text-accent%20font-poppins%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-[20px] sm:text-[24px] lg:text-3xl font-semibold leading-[28px] sm:leading-[32px] lg:leading-4xl text-center text-text-accent font-poppins">
            Media Partners
          </h2>

          {/* Grid Container */}
          <div data-component-id="src/app/MediaPartnersSection.tsx:222:10" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="222" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-secondary-background%20rounded-lg%20py-%5B30px%5D%20sm%3Apy-%5B45px%5D%20lg%3Apy-%5B60px%5D%20px-%5B20px%5D%20sm%3Apx-%5B40px%5D%20lg%3Apx-%5B54px%5D%20w-full%22%7D" className="bg-secondary-background rounded-lg py-[30px] sm:py-[45px] lg:py-[60px] px-[20px] sm:px-[40px] lg:px-[54px] w-full">
            <div data-component-id="src/app/MediaPartnersSection.tsx:223:12" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="223" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20grid%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20grid-cols-2%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20sm%3Agrid-cols-3%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20lg%3Agrid-cols-5%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20gap-6%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20justify-items-center%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20items-center%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
              className="
                grid 
                grid-cols-2 
                sm:grid-cols-3 
                lg:grid-cols-5 
                gap-6 
                justify-items-center 
                items-center
              "
            >
              {MediaPartnersLogos.map((partner, index) => (
                <Link data-component-id="src/app/MediaPartnersSection.tsx:235:16" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="235" data-component-file="MediaPartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22flex%20justify-center%20items-center%22%7D"
                  key={index}
                  href={partner.link}
                  target="_blank"
                  // rel={index === 0 ? "noopener noreferrer" : "noopener noreferrer nofollow"}
                  rel="noopener noreferrer nofollow"

                  className="flex justify-center items-center"
                >
                  <img data-component-id="src/app/MediaPartnersSection.tsx:244:18" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="244" data-component-file="MediaPartnersSection.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22w-%5B180px%5D%20h-%5B80px%5D%20object-contain%22%7D"
                    src={partner.src}
                    alt={partner.alt}
                     width={180}
                    height={80}
                    className="w-[180px] h-[80px] object-contain"
                  
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaPartnersSection;
